import React, { useEffect, useState } from 'react';
import {
  Input,
  Dropdown,
  FileUpload,
  Button,
  Confirmation,
  ValidationMessage,
  Modal,
  Toast,
} from '../../../common';
import { businessLicenseApi } from '../../../../services/apis';
import { validateForm, validation } from '../../../../utils/validation';
import { fileHandlerUrl } from '../../../../utils/consts/server';
import {
  ShowPasswordIcon,
  DeleteIcon,
  EditIcon,
} from '../../../../content/svg-component';
import { Conditional } from '../../../../utils/consts';
import { FormattedMessage } from 'react-intl';

const AddLicence = (props) => {
  const [licenseType, setLicenseType] = useState(''),
    [licenseNo, setLicenseNo] = useState(''),
    [licenseFile, setLicenseFile] = useState(''),
    [id, setId] = useState(''),
    [localId, setLocalId] = useState(''),
    [selectLicense, setSelectLicense] = useState(''),
    [licenseData, setLicenseData] = useState([]),
    [error, setError] = useState(),
    [isEditLicense, setIsEditLicense] = useState(false),
    [showLicenseImg, setShowLicenseImg] = useState(false),
    [showLoading, setShowLoading] = useState(true),
    [loading, setLoading] = useState(false),
    [showDeleteConfirm, setShowDeleteConfirm] = useState(false),
    [loadingImage, setLoadingImage] = useState(false),
    [toast, setToast] = useState(false),
    [toastState, setToastState] = useState('success'),
    [alertMessage, setAlertMessage] = useState('department.departmentdelete'),
    {
      intl,
      language: { direction, name },
      language,
      licenseList,
      licenseProviderLst,
      profileId,
      isCreateBusinessProfile,
      onChange = () => {},
      localLicenseData,
    } = props;

  useEffect(() => {
    if (isCreateBusinessProfile) {
      setLicenseData(localLicenseData);
      setShowLoading(false);
    } else {
      getLicenseData();
    }
  }, []);

  useEffect(() => {
    onChange(licenseData);
  }, [licenseData]);

  const getLicenseData = async () => {
    try {
      const {
        status,
        payload: { data },
      } = await businessLicenseApi.getAllByProfileId({
        profileId,
        pageNumber: 1,
        itemPerPage: 20,
      });
      if (status === 200) {
        setShowLoading(false);
        setLicenseData(data);
      }
    } catch (error) {
      setShowLoading(false);
      setToast(true);
      setToastState('danger');
      setAlertMessage('booking.servererror');
    }
  };

  const addLicenseData = async () => {
    try {
      setLoading(true);
      const { status } = await businessLicenseApi.insert({
        data: {
          profileId,
          licenseId: licenseType._id,
          licenseNo: licenseNo,
          licenseFile: licenseFile,
        },
      });
      if (status === 200) {
        setToast(true);
        setToastState('success');
        setAlertMessage('profile.quotaadd');
        setLoading(false);
        getLicenseData();
        resetStates();
      }
    } catch (error) {
      setToast(true);
      setToastState('danger');
      setAlertMessage('booking.servererror');
      setLoading(false);
    }
  };

  const updateLicenseData = async () => {
    try {
      setLoading(true);
      const { status } = await businessLicenseApi.update({
        data: {
          profileId,
          _id: id,
          licenseId: licenseType._id,
          licenseNo: licenseNo,
          licenseFile: licenseFile,
        },
      });
      if (status === 200) {
        setToast(true);
        setToastState('success');
        setAlertMessage('department.departmentaddInformation');
        setLoading(false);
        getLicenseData();
        resetStates();
      }
    } catch (error) {
      setToast(true);
      setToastState('danger');
      setAlertMessage('booking.servererror');
      setLoading(false);
    }
  };

  const deleteLicenseData = async () => {
    try {
      setLoading(true);
      setShowLoading(true);
      const { status } = await businessLicenseApi.deleteLicense({
        _id: id,
      });
      if (status === 200) {
        setToast(true);
        setToastState('success');
        setAlertMessage('department.departmentdelete');
        setLoading(false);
        setShowDeleteConfirm(false);
        getLicenseData();
      }
    } catch (error) {
      setToast(true);
      setToastState('danger');
      setAlertMessage('booking.servererror');
      setLoading(false);
      setShowDeleteConfirm(false);
    }
  };

  const addLocalLicense = () => {
    const data = {
      id: licenseData.length,
      license: licenseType,
      licenseNo: licenseNo,
      licenseFile: licenseFile,
      reference: licenseType?.reference,
    };
    setLicenseData([data, ...licenseData]);
    resetStates();
    setToast(true);
    setToastState('success');
    setAlertMessage('profile.quotaadd');
  };

  const updateLocalLicense = () => {
    let newLicenseData = licenseData.map((item, index) => {
      if (item.id === localId) {
        return {
          id: index,
          license: [licenseType],
          licenseNo: licenseNo,
          licenseFile: licenseFile,
        };
      } else {
        return item;
      }
    });
    setLicenseData(newLicenseData);
    setToast(true);
    setToastState('success');
    setAlertMessage('department.departmentaddInformation');
    resetStates();
  };

  const deleteLocalLicense = () => {
    let newLicenseData = licenseData.filter((item) => item.id !== localId);
    setLicenseData(newLicenseData);
    setLocalId('');
    setToast(true);
    setToastState('success');
    setAlertMessage('department.departmentdelete');
    setShowDeleteConfirm(false);
    resetStates();
  };

  const doSubmit = () => {
    if (isCreateBusinessProfile) {
      isEditLicense ? updateLocalLicense() : addLocalLicense();
    } else {
      isEditLicense ? updateLicenseData() : addLicenseData();
    }
    setSelectLicense('');
  };

  const handleValidation = () => {
    const { result, error } = validateForm({
      licenseId: validation.number(licenseNo).required().errors,
      licenseFile: validation.required(licenseFile).errors,
    });
    return { result, error };
  };

  const selectLicenseData = (item) => {
    setLicenseType(item?.license),
      setLicenseNo(item?.licenseNo),
      setLicenseFile(item?.licenseFile);
    setId(item?._id);
    setIsEditLicense(true);
  };

  const resetStates = () => {
    setLicenseFile('');
    setLicenseNo('');
    setLicenseType('');
    setIsEditLicense(false);
  };

  let imageURL = licenseFile
    ? `${fileHandlerUrl}/file/show/${licenseFile ?? ''}
  `
    : require('./../../../../content/images/common/no-image.png');
  return (
    <>
      <div>
        <div
          className="d-flex col-12 align-items-center flex-wrap px-0 pt-sm-3"
          key={`license`}
        >
          <Toast
            isOpen={toast}
            onClose={() => setToast(false)}
            state={toastState}
            position="bottom"
            message={intl.formatMessage({
              id: alertMessage,
            })}
            direction={direction}
          />
          <Confirmation
            isConfirmation={true}
            onReject={() => setShowDeleteConfirm(false)}
            onSubmit={() => {
              isCreateBusinessProfile
                ? deleteLocalLicense()
                : deleteLicenseData();
            }}
            show={showDeleteConfirm}
            type="warning"
            title="profile.delete"
            defaultDescription="profile.deleteconfirmation"
            body="profile.deleteconfirmation"
          />
          <Modal
            id="licenseImg"
            detailClass={'align-self-start text-third-dark'}
            titleClass={'text-primary'}
            title={<FormattedMessage id="profile.viewlicense" />}
            modalSize={'modal-xl'}
            isOpen={showLicenseImg}
            onClose={() => {
              setShowLicenseImg(false);
            }}
          >
            <div className="w-100 d-flex px-0 pt-2 justify-content-center align-items-center">
              <img
                src={imageURL}
                alt="image"
                className="rounded-1 col-sm-7 col-12 license-image"
                height={400}
              />
            </div>
          </Modal>
          <div className="w-100">
            <Conditional checkRender={licenseData.length > 0}>
              <div className="w-100 pb-4 table-responsive">
                <table className="table table-bordered text-start font-small table-striped table-bordered">
                  <thead className="text-nowrap text-white font-weight-bold bg-secondary">
                    <tr>
                      <th className="text-white text-center" scope="col">
                        {intl.formatMessage({ id: 'profile.row' })}
                      </th>
                      <th className="text-white text-center" scope="col">
                        {intl.formatMessage({ id: 'profile.licensetype' })}
                      </th>
                      <th className="text-white text-center" scope="col">
                        {intl.formatMessage({ id: 'profile.licenseno' })}
                      </th>
                      <th className="text-white text-center" scope="col">
                        {intl.formatMessage({ id: 'profile.reference' })}
                      </th>
                      <th className="text-white text-center col-2" scope="col">
                        {intl.formatMessage({ id: 'profile.activities' })}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {licenseData.map((item, index) => {
                      return (
                        <React.Fragment key={`license-${index}`}>
                          <tr
                            className={`cursor-pointer ${
                              selectLicense === `license-${index}`
                                ? 'text-primary'
                                : 'text-third'
                            }`}
                            onClick={() => {
                              selectLicenseData(item);
                              setLocalId(item?.id);
                              setSelectLicense(`license-${index}`);
                            }}
                          >
                            <td className="text-nowrap" scope="row">
                              {index + 1}
                            </td>
                            <td className="text-nowrap text-center" scope="row">
                              {item?.license?.description?.[name]}
                            </td>
                            <td className="text-nowrap text-center" scope="row">
                              {item?.licenseNo}
                            </td>
                            <td className="text-nowrap text-center" scope="row">
                              {item?.reference?.description?.[name]}
                            </td>
                            <td
                              className="text-third d-flex flex-row justify-content-center text-nowrap d-flex flex-row"
                              scope="row"
                              onClick={(event) => event.stopPropagation()}
                            >
                              <div
                                className="px-2 cursor-pointer"
                                onClick={(event) => {
                                  setShowLicenseImg(true),
                                    setLicenseFile(item?.licenseFile);
                                }}
                              >
                                <ShowPasswordIcon size={22} color="#b2b4b7" />
                              </div>
                              <div
                                className="px-2 cursor-pointer"
                                onClick={() => {
                                  selectLicenseData(item);
                                  setLocalId(item.id);
                                  setSelectLicense(`license-${index}`);
                                }}
                              >
                                <EditIcon size={18} color="#b2b4b7" />
                              </div>
                              <div
                                className="cursor-pointer"
                                onClick={() => {
                                  setShowDeleteConfirm(true),
                                    setId(item?._id),
                                    setLocalId(item.id);
                                }}
                              >
                                <DeleteIcon size={22} color="red" />
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </Conditional>
            <Conditional checkRender={licenseData.length === 0 && !showLoading}>
              <div className="w-100 px-0 pb-3 d-flex flex-xs-row flex-column">
                <div className="flex-grow-1 invite-form-container col-md-6 col-xs-7 w-100 px-md-3 px-0">
                  <div className="w-100 d-flex flex-row justify-content-start ">
                    <img
                      className="img-fluid default-border-radius-small w-100 img-setup"
                      alt=""
                      src={require('../../../../content/images/elements/addFiles.png')}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-xs-5 col-12 px-md-3 px-xs-1 px-3 py-xs-0 py-3 d-flex flex-column justify-content-start align-items-start">
                  <div className="w-100 d-flex flex-column justify-content-start align-items-start">
                    <span className="text-primary pt-md-5 pt-2 font-sm-xxlarge font-normal text-nowrap">
                      <FormattedMessage id={`profile.addlicense`} />
                    </span>
                    <div className="col-md-10 w-100 text-third text-start pt-md-4 pt-sm-3 pt-1 px-0">
                      <p className="font-xl-small font-sm-msmall font-xs-xsmall font-msmall lineHeight">
                        <FormattedMessage id={`profile.addLicenseText`} />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Conditional>
            <Conditional checkRender={licenseData.length === 0 && showLoading}>
              <div className="w-100 text-center mb-4">
                <FormattedMessage id="booking.loading" />
              </div>
            </Conditional>
          </div>
          <div className="col-sm-6 col-12 add-bussines-input-font editBusinessProfilePage pt-3 px-3">
            <Dropdown
              classNames={'bg-third-light height-55px'}
              value={licenseType?._id}
              id={`licenseType`}
              name={`licenseType`}
              options={{
                data: licenseList,
                label: `name`,
                value: '_id',
                isMultiLanguage: true,
              }}
              label="profile.licensetype"
              onChange={(event) => {
                const { valueObject } = event.currentTarget;
                setLicenseType(valueObject);
              }}
              maxHeight={'55px'}
              outSideLabel={true}
              labelPosition={'top'}
              withoutShadow={true}
              outSideLabelClass={`${
                direction === 'rtl'
                  ? 'font-normal'
                  : 'font-xxl-normal font-xl-small font-lg-msmall font-smaller font-weight-bold text-nowrap'
              }`}
            />
            <ValidationMessage errors={error?.licenseType} />
          </div>
          <div className="col-sm-6 col-12 add-bussines-input-font editBusinessProfilePage pt-3 px-3">
            <Input
              type="text"
              name={`licenseNo`}
              value={licenseNo}
              label={intl.formatMessage({
                id: 'profile.licenseno',
              })}
              onChange={(event) => {
                setError({
                  licenseNo: validation.number(event.target.value).required()
                    .errors,
                });
                setLicenseNo(event.target.value);
              }}
              className={`${direction}-text`}
              inputClassName={
                'font-normal height-input-profile px-sm-3 px-3 text-start'
              }
              language={language}
              outSideLabel={true}
              outSideLabelClass={`text-dark ${
                direction === 'rtl'
                  ? 'font-normal'
                  : 'font-xxl-normal font-xl-small font-lg-msmall font-smaller font-weight-bold text-nowrap'
              }`}
              outSideLabelPosition={'top'}
            />
            <ValidationMessage errors={error?.licenseNo} />
          </div>
          <div className="col-sm-6 col-12 d-flex flex-row justify-content-end">
            <div
              className={`w-100 d-flex align-items-center px-1 ${
                direction === 'rtl'
                  ? ' pt-sm-3 pt-4 mt-sm-2 mt-0'
                  : 'pt-md-3 pt-sm-2 pt-3 pt-4 mt-xl-2 mt-md-1 mt-sm-2 mt-0'
              } cursor-pointer`}
            >
              <div className="position-relative editbusiness  cursor-pointer w-100 d-flex justify-content-end align-items-end">
                <FileUpload
                  title={intl.formatMessage({
                    id: loadingImage
                      ? 'booking.loading'
                      : 'profile.uploadlicense',
                  })}
                  className="bg-third-light align-items-center text-dark default-border-radius-small border mt-2 tripsi-height"
                  isOptional={true}
                  recieveFile={(item) => {
                    setLicenseFile(item);
                    !item &&
                      (setToast(true),
                      setToastState('danger'),
                      setAlertMessage('user.tryagain'));
                  }}
                  giveFeedBack={(event) => setLoadingImage(event?.loadingData)}
                />
                {licenseFile && (
                  <span
                    className="text-nowrap font-msmall text-primary position-absolute cursor-pointer"
                    style={{
                      bottom: '-25px',
                      textDecoration: 'underline',
                    }}
                    onClick={() => setShowLicenseImg(true)}
                  >
                    <FormattedMessage id="profile.licensepic" />
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="w-100 d-flex flex-sm-row flex-column-reverse align-items-end pt-4 mt-4 mb-4">
            <div className="col-sm-6 col-12 px-3 pt-sm-0 mt-sm-0 pt-4 mt-4">
              <Button
                name={`reset-licnse-inputs`}
                id={`reset-licnse-inputs`}
                className="btn-third"
                label={intl.formatMessage({
                  id: 'profile.reload',
                })}
                onClick={() => {
                  resetStates();
                  setSelectLicense('');
                }}
              />
            </div>
            <div className="d-flex flex-row justify-content-sm-end jusstify-content-start col-sm-6 col-12 px-3">
              <Button
                name={`insert-licenseData`}
                id={`insert-licenseData`}
                type="submit"
                className="btn-secondary"
                label={intl.formatMessage({
                  id: `${
                    isEditLicense
                      ? 'profile.editingInformation'
                      : 'profile.insertinformation'
                  }`,
                })}
                onClick={() => {
                  doSubmit();
                }}
                disabled={loading || !handleValidation().result}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddLicence;
